(function () {
  var QUESTIONS = [
    { id: 'palette', prompt: 'Which color palette pulls you in?', options: [
      { label: 'Warm neutrals and wood tones', value: 'warm_neutral', scores: { farmhouse: 2, organic_modern: 2, scandinavian: 1 } },
      { label: 'Crisp whites and black accents', value: 'high_contrast', scores: { modern: 2, minimalist: 1, industrial: 1 } },
      { label: 'Deep jewel tones', value: 'jewel', scores: { traditional: 2, luxury: 2, bohemian: 1 } },
      { label: 'Soft blues and sandy tans', value: 'coastal', scores: { coastal: 3 } }
    ]},
    { id: 'lines', prompt: 'What kind of furniture silhouette feels right?', options: [
      { label: 'Clean, straight lines', value: 'clean', scores: { modern: 2, minimalist: 2, scandinavian: 1 } },
      { label: 'Curved, organic shapes', value: 'organic', scores: { organic_modern: 2, japandi: 1, coastal: 1, bohemian: 1 } },
      { label: 'Ornate, detailed carving', value: 'ornate', scores: { traditional: 2, luxury: 2 } },
      { label: 'Raw, industrial edges', value: 'industrial', scores: { industrial: 3 } }
    ]},
    { id: 'materials', prompt: 'Which materials do you gravitate toward?', options: [
      { label: 'Light oak and linen', value: 'scandi_material', scores: { scandinavian: 3, japandi: 1 } },
      { label: 'Blackened steel and leather', value: 'industrial_material', scores: { industrial: 3 } },
      { label: 'Rattan, jute and natural fiber', value: 'organic_material', scores: { organic_modern: 2, coastal: 1, farmhouse: 1, bohemian: 2 } },
      { label: 'Polished marble and brass', value: 'luxury_material', scores: { luxury: 3 } }
    ]},
    { id: 'mood', prompt: 'Pick the mood you want a room to have.', options: [
      { label: 'Calm and uncluttered', value: 'minimalist_mood', scores: { minimalist: 2, japandi: 2 } },
      { label: 'Collected and lived-in', value: 'farmhouse_mood', scores: { farmhouse: 3, bohemian: 1 } },
      { label: 'Sleek and editorial', value: 'modern_mood', scores: { modern: 3 } },
      { label: 'Warm and worldly', value: 'traditional_mood', scores: { traditional: 3, bohemian: 1 } }
    ]},
    { id: 'era', prompt: 'Which era of design speaks to you?', options: [
      { label: '1950s-60s', value: 'midcentury', scores: { midcentury: 3 } },
      { label: 'Right now, or next year', value: 'contemporary', scores: { modern: 2, minimalist: 1 } },
      { label: 'Timeless, no particular era', value: 'timeless', scores: { traditional: 2, luxury: 1 } },
      { label: 'Old-world European', value: 'old_world', scores: { traditional: 3, luxury: 1 } }
    ]},
    { id: 'pattern', prompt: 'How do you feel about pattern?', options: [
      { label: 'None, keep it solid', value: 'minimalist_pattern', scores: { minimalist: 2, japandi: 1 } },
      { label: 'A little texture, no prints', value: 'organic_pattern', scores: { organic_modern: 2, scandinavian: 1 } },
      { label: 'Bold pattern in small doses', value: 'eclectic_pattern', scores: { farmhouse: 1, traditional: 1, luxury: 1, bohemian: 3 } },
      { label: 'Layer it on', value: 'maximalist_pattern', scores: { traditional: 2, luxury: 2, bohemian: 2 } }
    ]},
    { id: 'lighting', prompt: 'Pick a lighting style.', options: [
      { label: 'Sculptural statement fixture', value: 'modern_light', scores: { modern: 2, minimalist: 1 } },
      { label: 'Woven or rattan pendant', value: 'organic_light', scores: { organic_modern: 2, coastal: 1, japandi: 1, bohemian: 1 } },
      { label: 'Exposed bulb or metal cage', value: 'industrial_light', scores: { industrial: 3 } },
      { label: 'Crystal or brass chandelier', value: 'luxury_light', scores: { luxury: 3 } }
    ]},
    { id: 'inspiration', prompt: 'Last one - where would you rather spend an afternoon?', options: [
      { label: 'A minimalist Tokyo apartment', value: 'japandi', scores: { japandi: 3 } },
      { label: 'A California beach house', value: 'coastal', scores: { coastal: 3 } },
      { label: 'A restored farmhouse', value: 'farmhouse', scores: { farmhouse: 3 } },
      { label: 'A colorful traveler\u2019s loft full of plants and textiles', value: 'bohemian', scores: { bohemian: 3 } }
    ]}
  ];

  var STYLE_LABELS = {
    modern: 'Modern', japandi: 'Japandi', organic_modern: 'Organic Modern',
    scandinavian: 'Scandinavian', industrial: 'Industrial', midcentury: 'Mid-Century',
    minimalist: 'Minimalist', coastal: 'Coastal', farmhouse: 'Farmhouse',
    traditional: 'Traditional', luxury: 'Luxury', bohemian: 'Bohemian'
  };

  var STYLE_BLURBS = {
    modern: 'You lean toward sleek, uncluttered spaces where every piece earns its place.',
    japandi: 'You love the calm of Japanese minimalism blended with Scandinavian warmth.',
    organic_modern: 'You are drawn to natural materials and soft, curved shapes that feel effortless.',
    scandinavian: 'You favor light woods, function, and cozy simplicity above all else.',
    industrial: 'You gravitate toward raw materials, exposed structure, and a bit of edge.',
    midcentury: 'You love the warmth and iconic silhouettes of mid-century design.',
    minimalist: 'You want calm, breathing room, and nothing you do not need.',
    coastal: 'You are drawn to airy, light-filled rooms with a relaxed, breezy feel.',
    farmhouse: 'You love a collected, lived-in look with warmth and character.',
    traditional: 'You appreciate timeless, classic pieces with a sense of history.',
    luxury: 'You gravitate toward rich materials and a refined, elevated feel.',
    bohemian: 'You love eclectic decor, layered pattern, and a relaxed, artistic vibe.'
  };

  var STYLE_COLLECTION_HANDLES = {
    modern: 'style-modern', japandi: 'style-japandi', organic_modern: 'style-organic-modern',
    scandinavian: 'style-scandinavian', industrial: 'style-industrial', midcentury: 'style-mid-century',
    minimalist: 'style-minimalist', coastal: 'style-coastal', farmhouse: 'style-farmhouse',
    traditional: 'style-traditional', luxury: 'style-luxury', bohemian: 'style-bohemian'
  };

  var root = document.querySelector('[data-studio-quiz]');
  if (!root) return;

  var introStep, questionsForm, questionList, progressBar, backBtn, nextBtn, resultEl, errorEl;
  var currentIndex = 0;
  var answers = {};

  function init() {
    introStep = root.querySelector('[data-quiz-step="intro"]');
    questionsForm = root.querySelector('[data-quiz-questions]');
    questionList = root.querySelector('[data-quiz-question-list]');
    progressBar = root.querySelector('[data-quiz-progress-bar]');
    backBtn = root.querySelector('[data-quiz-back]');
    nextBtn = root.querySelector('[data-quiz-next]');
    resultEl = root.querySelector('[data-quiz-result]');
    errorEl = root.querySelector('[data-quiz-error]');

    var startBtn = root.querySelector('[data-quiz-start]');
    if (startBtn) startBtn.addEventListener('click', startQuiz);
    if (backBtn) backBtn.addEventListener('click', goBack);
    if (nextBtn) nextBtn.addEventListener('click', goNext);

    var retakeBtn = root.querySelector('[data-quiz-retake]');
    if (retakeBtn) retakeBtn.addEventListener('click', resetQuiz);
  }

  function startQuiz() {
    introStep.hidden = true;
    questionsForm.hidden = false;
    currentIndex = 0;
    renderQuestion();
  }

  function renderQuestion() {
    var q = QUESTIONS[currentIndex];
    progressBar.style.width = Math.round((currentIndex / QUESTIONS.length) * 100) + '%';
    backBtn.hidden = currentIndex === 0;
    nextBtn.textContent = currentIndex === QUESTIONS.length - 1 ? 'See My Results' : 'Next';

    var html = '<fieldset class="studio-quiz__question">' +
      '<legend>' + escapeHtml(q.prompt) + '</legend>' +
      q.options.map(function (opt) {
        var checked = answers[q.id] === opt.value ? 'checked' : '';
        return '<label class="studio-quiz__option">' +
          '<input type="radio" name="' + q.id + '" value="' + opt.value + '" ' + checked + '>' +
          '<span>' + escapeHtml(opt.label) + '</span>' +
          '</label>';
      }).join('') +
      '</fieldset>';
    questionList.innerHTML = html;
  }

  function goBack() {
    saveCurrentAnswer();
    if (currentIndex > 0) {
      currentIndex -= 1;
      renderQuestion();
    }
  }

  function goNext() {
    var q = QUESTIONS[currentIndex];
    var selected = questionList.querySelector('input[name="' + q.id + '"]:checked');
    if (!selected) {
      showError('Pick an option to continue.');
      return;
    }
    clearError();
    saveCurrentAnswer();

    if (currentIndex === QUESTIONS.length - 1) {
      showResult();
    } else {
      currentIndex += 1;
      renderQuestion();
    }
  }

  function saveCurrentAnswer() {
    var q = QUESTIONS[currentIndex];
    var selected = questionList.querySelector('input[name="' + q.id + '"]:checked');
    if (selected) answers[q.id] = selected.value;
  }

  function showResult() {
    questionsForm.hidden = true;

    var totals = {};
    QUESTIONS.forEach(function (q) {
      var chosenValue = answers[q.id];
      var opt = q.options.filter(function (o) { return o.value === chosenValue; })[0];
      if (!opt) return;
      Object.keys(opt.scores).forEach(function (style) {
        totals[style] = (totals[style] || 0) + opt.scores[style];
      });
    });

    var ranked = Object.keys(totals).sort(function (a, b) { return totals[b] - totals[a]; });
    var primary = ranked[0] || 'modern';
    var secondary = ranked[1] || ranked[0] || 'minimalist';

    resultEl.hidden = false;
    resultEl.querySelector('[data-result-primary]').textContent = STYLE_LABELS[primary];
    resultEl.querySelector('[data-result-secondary]').textContent = STYLE_LABELS[secondary];
    resultEl.querySelector('[data-result-blurb]').textContent = STYLE_BLURBS[primary];
    var shopLink = resultEl.querySelector('[data-result-shop-link]');
    if (shopLink) shopLink.href = '/collections/' + STYLE_COLLECTION_HANDLES[primary];
  }

  function resetQuiz() {
    answers = {};
    currentIndex = 0;
    resultEl.hidden = true;
    introStep.hidden = false;
  }

  function showError(msg) {
    errorEl.hidden = false;
    errorEl.textContent = msg;
  }

  function clearError() {
    errorEl.hidden = true;
    errorEl.textContent = '';
  }

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.textContent = str;
    return div.innerHTML;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
